import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'lvr-hint-banner',
	standalone: true,
	imports: [MatIcon],
	templateUrl: './hint-banner.html',
	styleUrl: './hint-banner.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LvrHintBanner {
	public readonly title = input<string>('');
	public readonly message = input<string>('');
	public readonly icon = input<string>('info_outline');
}
